import { authHeaders } from 'functions/authHeader';
import { GA_CHAT_EVENTS } from 'modules/ga/generalEvents';
import app from 'new-ui/app';
import configs from 'configs';

const apiUrl = configs.beApiUrl;

export const sendMessage = async (prompt, data) => {
  const payload = JSON.stringify({
    question: prompt,
    overrideConfig: {
      vars: {
        payload: { ...data },
      },
    },
  });

  try {
    app.sendGoogleAnalyticsEvent(GA_CHAT_EVENTS.PROFILE_CHAT_USER_SEND_MESSAGE_TO_CHAT, 'user send msg to chat');
    const response = await fetch(`${apiUrl}/chatReturnUser/newUserMsg`, {
      method: 'POST',
      headers: await authHeaders(),
      body: payload,
    });

    if (!response.ok) {
      throw new Error(`Error sending message: ${response.statusText}`);
    }

    const ans = await response.json();
    return ans;
  } catch (error) {
    console.error('Error sending message:', error);
  }
};
